//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
import { MODAL_NAME } from './constants'

export const open = (params: { name: string; [key: string]: any }) =>
  LKModalActions.open({ name: MODAL_NAME, ...params })
